import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { targetTime: String }
  static targets = ["dniContainer", "godzinyContainer", "minutyContainer", "dni", "godziny", "minuty", "sekundy"]

  connect() {
    this.tick()
    this.interval = setInterval(this.tick.bind(this), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  tick() {
    const diff = new Date(this.targetTimeValue) - Date.now()

    if (diff <= 0) {
      this.element.classList.add("hidden")
      clearInterval(this.interval)
      return
    }

    const totalSeconds = Math.floor(diff / 1000)
    const days = Math.floor(totalSeconds / 86400)
    const hours = Math.floor((totalSeconds % 86400) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    this.dniTarget.style.setProperty("--value", days)
    this.godzinyTarget.style.setProperty("--value", hours)
    this.minutyTarget.style.setProperty("--value", minutes)
    this.sekundyTarget.style.setProperty("--value", seconds)

    this.dniContainerTarget.classList.toggle("hidden", days === 0)
    this.godzinyContainerTarget.classList.toggle("hidden", days === 0 && hours === 0)
    this.minutyContainerTarget.classList.toggle("hidden", days === 0 && hours === 0 && minutes === 0)
  }
}
